import { Phase } from '../atoms/reviewPricing.primitives.atoms'

export const generateDefaultPhase = (): Phase => ({
  id: crypto.randomUUID(),
  name: '',
  duration: { years: 1, days: -1 },
  priceIds: [],
  minimums: [],
  discounts: [],
  recurrencePreference: 'RESET',
  phasePriceMetadata: []
})
